import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minPhoneNumberLength(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control?.value) {
      return null;
    }

    const phoneNumber = control.value.split(' ')[1] || '';
    const message = phoneNumber ? $localize`Please check your dialing code and enter a valid phone number` : $localize`This question is required`;
    return phoneNumber.length >= minLength ? null : { minPhoneLength: { message } };
  };
}
